import {
    LOCATION_CENTER,
    LOCATION_DOT_R,
    LOCATION_ICON_SIZE,
    LOCATION_ICON_STROKE_WIDTH,
    LOCATION_OUTER_R,
    LOCATION_TICK_INNER_END,
    LOCATION_TICK_INNER_START,
    LOCATION_TICK_OUTER_END,
    LOCATION_TICK_OUTER_START,
    SAVED_DIVIDER_X_END,
    SAVED_DIVIDER_X_START,
    SAVED_DIVIDER_Y,
    SAVED_ICON_SIZE,
    SAVED_ICON_STROKE_WIDTH,
    SAVED_LEG_LEFT_X,
    SAVED_LEG_RIGHT_X,
    SAVED_LEG_Y_END,
    SAVED_LEG_Y_START,
    SAVED_RECT_HEIGHT,
    SAVED_RECT_RX,
    SAVED_RECT_WIDTH,
    SAVED_RECT_X,
    SAVED_RECT_Y
} from './constants';

// Quick-action chip icons — rendered inline so the chip's currentColor
// cascade tints them the airspace-advisory blue. Extracted to keep the main
// SearchDrawer component under the 100-line budget.

export const LocationIcon = (): JSX.Element => (
    <svg
        aria-hidden='true'
        fill='none'
        height={LOCATION_ICON_SIZE}
        viewBox={`0 0 ${LOCATION_ICON_SIZE} ${LOCATION_ICON_SIZE}`}
        width={LOCATION_ICON_SIZE}
        xmlns='http://www.w3.org/2000/svg'>
        <circle cx={LOCATION_CENTER} cy={LOCATION_CENTER} fill='currentColor' r={LOCATION_DOT_R} />

        <circle
            cx={LOCATION_CENTER}
            cy={LOCATION_CENTER}
            r={LOCATION_OUTER_R}
            stroke='currentColor'
            strokeWidth={LOCATION_ICON_STROKE_WIDTH}
        />

        <line
            stroke='currentColor'
            strokeWidth={LOCATION_ICON_STROKE_WIDTH}
            x1={LOCATION_CENTER}
            x2={LOCATION_CENTER}
            y1={LOCATION_TICK_OUTER_START}
            y2={LOCATION_TICK_INNER_START}
        />

        <line
            stroke='currentColor'
            strokeWidth={LOCATION_ICON_STROKE_WIDTH}
            x1={LOCATION_CENTER}
            x2={LOCATION_CENTER}
            y1={LOCATION_TICK_INNER_END}
            y2={LOCATION_TICK_OUTER_END}
        />

        <line
            stroke='currentColor'
            strokeWidth={LOCATION_ICON_STROKE_WIDTH}
            x1={LOCATION_TICK_OUTER_START}
            x2={LOCATION_TICK_INNER_START}
            y1={LOCATION_CENTER}
            y2={LOCATION_CENTER}
        />

        <line
            stroke='currentColor'
            strokeWidth={LOCATION_ICON_STROKE_WIDTH}
            x1={LOCATION_TICK_INNER_END}
            x2={LOCATION_TICK_OUTER_END}
            y1={LOCATION_CENTER}
            y2={LOCATION_CENTER}
        />
    </svg>
);

export const SavedPlacesIcon = (): JSX.Element => (
    <svg
        aria-hidden='true'
        fill='none'
        height={SAVED_ICON_SIZE}
        viewBox={`0 0 ${SAVED_ICON_SIZE} ${SAVED_ICON_SIZE}`}
        width={SAVED_ICON_SIZE}
        xmlns='http://www.w3.org/2000/svg'>
        <rect
            height={SAVED_RECT_HEIGHT}
            rx={SAVED_RECT_RX}
            stroke='currentColor'
            strokeWidth={SAVED_ICON_STROKE_WIDTH}
            width={SAVED_RECT_WIDTH}
            x={SAVED_RECT_X}
            y={SAVED_RECT_Y}
        />

        <line
            stroke='currentColor'
            strokeLinecap='round'
            strokeWidth={SAVED_ICON_STROKE_WIDTH}
            x1={SAVED_LEG_LEFT_X}
            x2={SAVED_LEG_LEFT_X}
            y1={SAVED_LEG_Y_START}
            y2={SAVED_LEG_Y_END}
        />

        <line
            stroke='currentColor'
            strokeLinecap='round'
            strokeWidth={SAVED_ICON_STROKE_WIDTH}
            x1={SAVED_LEG_RIGHT_X}
            x2={SAVED_LEG_RIGHT_X}
            y1={SAVED_LEG_Y_START}
            y2={SAVED_LEG_Y_END}
        />

        <line
            stroke='currentColor'
            strokeWidth={SAVED_ICON_STROKE_WIDTH}
            x1={SAVED_DIVIDER_X_START}
            x2={SAVED_DIVIDER_X_END}
            y1={SAVED_DIVIDER_Y}
            y2={SAVED_DIVIDER_Y}
        />
    </svg>
);
